import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader } from '../ui/card';
import { Badge } from '../ui/badge';
import { cardAnimation } from './animations';

const WHATSAPP_LINK = 'https://wa.me/523312949249?text=Quiero%20mi%20menú%20digital%20para%20mi%20negocio';

export const PricingCard = ({ plan, index, highlighted }) => {
  const Icon = plan.icon;
  
  return (
    <motion.div
      {...cardAnimation(index)}
      className={highlighted ? 'lg:scale-105' : ''}
    >
      <Card
        className={`h-full glass-card border-border/50 transition-all duration-300 relative overflow-hidden ${
          highlighted
            ? 'border-primary/50 shadow-[0_0_40px_hsl(var(--primary)/0.15)]'
            : 'hover:border-primary/30'
        }`}
      >
        {highlighted && (
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary via-primary-glow to-primary" />
        )}
        
        <CardHeader className="p-6 pb-4">
          <div className="flex items-start justify-between mb-4">
            <div className="p-3 rounded-xl bg-primary/10">
              <Icon className="w-6 h-6 text-primary" />
            </div>
            {plan.badge && (
              <Badge className="bg-primary/20 text-primary border-primary/30">
                {plan.badge}
              </Badge>
            )}
          </div>
          
          <h3 className="text-2xl font-bold mb-2">{plan.name}</h3>
          <p className="text-sm text-muted-foreground mb-4">{plan.description}</p>
          
          <div className="flex items-baseline gap-2">
            <span className="text-4xl font-bold text-foreground">{plan.price}</span>
            <span className="text-sm text-muted-foreground">{plan.currency}</span>
          </div>
        </CardHeader>
        
        <CardContent className="p-6 pt-0">
          <Button
            className="w-full mb-6 bg-gradient-to-r from-[hsl(var(--cta-orange))] to-[hsl(var(--cta-orange-hover))] text-white hover:shadow-[0_0_30px_hsl(var(--cta-orange)/0.4)]"
            onClick={() => window.open(WHATSAPP_LINK, '_blank')}
          >
            {highlighted ? 'Comenzar ahora' : 'Seleccionar plan'}
          </Button>
          
          <div className="space-y-3">
            {plan.features.map((feature) => (
              <div key={`${plan.id}-${feature}`} className="flex items-start gap-3">
                <Check className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <span className="text-sm text-foreground">{feature}</span>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};
